export const mapDataToDropdown = (data, nameKey) => {
    const clients = [];
    const keys = Object.keys(data);
    keys.forEach((key) => {
        clients.push({ value: data[key].id, label: data[key].attributes[nameKey] });
    });
    return clients;
};
